<style>
  table {
    width: 100%; /* Make the table take full width of its container */
    border-collapse: collapse; /* Ensures borders touch */
  }
  tr td {
    width: 50%; /* Each column gets 50% of the table width */
    padding: 0 10px; /* Add some padding for readability */
  }
  .pl-8 {
    padding-left: 8px;
  }
  .pl-16 {
    padding-left: 16px;
  }
  .text-justify {
    text-align: justify;
  }
</style>
<!-- Page 1 -->
<div class="pdf-page app-cp-00-90-07-88" id="cp900788">
  <h3 style="display: flex; justify-content: end" class="font-medium">
    <b>COMMERCIAL PROPERTY</b>
  </h3>
  <br />
  <h3 class="font-large" style="text-align: center">
    <b>COMMERCIAL PROPERTY CONDITIONS</b>
  </h3>
  <p class="font-small" style="text-align: center">
    This Coverage Part is subject to the following conditions, the Common Policy
    Conditions and applicable Loss Conditions and Additional Conditions in
    Commercial Property Coverage Forms.
  </p>
  <table
    style="
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      border-spacing: 20px 0;
    "
  >
    <thead>
      <tr>
        <th style="width: 50%"></th>
        <th style="width: 50%"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="width: 50%">
          <h3 class="font-small">
            <b>A. CONCEALMENT, MISREPRESENTATION OR FRAUD</b>
          </h3>
        </td>
        <td style="width: 50%; vertical-align: top">
          <h3 class="font-small"><b>F. NO BENEFIT TO BAILEE</b></h3>
        </td>
      </tr>
      <tr>
        <td class="pl-16" style="vertical-align: top">
          <p class="text-justify">
            This Coverage Part is void in any case of fraud by you as it relates
            to this Coverage Part at any time. It is also void if you or any
            other insured, at any time, intentionally conceal or misrepresent a
            material fact concerning:
          </p>
          <ol>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">This Coverage Part;</span></li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">The Covered Property </span> </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
              Your interest in the Covered Property; or
            </span>
            </li>
            <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">A claim under this Coverage Part </span></li>
          </ol>
          <h3 class="font-small"><b>B. CONTROL OF PROPERTY</b></h3>
          <div class="pl-16">
            <p class="text-justify">
              Any act or neglect of any person other than you beyond your
              direction or control will not affect this insurance.
            </p>
            <p class="text-justify">
              The breach of any condition of this Coverage Part at any one or
              more locations will not affect coverage at any location where, at
              the time of loss or damage, the breach of condition does not
              exist.
            </p>
          </div>
          <h3 class="font-small">
            <b>C. INSURANCE UNDER TWO OR MORE COVERAGES</b>
          </h3>
          <div class="pl-16">
            <p class="text-justify">
              If two or more of this policy's coverages apply to the same loss
              or damage, we will not pay more than the actual amount of the loss
              or damage.
            </p>
          </div>
          <h3 class="font-small"><b>D. LEGAL ACTION AGAINST US</b></h3>
          <div class="pl-16">
            <p class="text-justify">
              No one may bring a legal action against us under this Coverage
              Part unless:
            </p>
            <ol>
              <li class="text-justify" style="font-weight: bold; padding-bottom: 10px;">
                <span style="font-weight: normal;"> 
                There has been full compliance with all of the terms of this
                Coverage Part; and
              </span>
              </li>
              <li class="text-justify" style="font-weight: bold; padding-bottom: 10px;">
                <span style="font-weight: normal;">
                The action is brought within 2 years after the date on which the
                direct physical loss or damage occurred
              </span>
              </li>
            </ol>
          </div>
          <h3 class="font-small"><b>E. LIBERALIZATION</b></h3>
          <div class="pl-16">
            <p class="text-justify">
              If we adopt any revision that would broaden the coverage under
              this Coverage Part without additional premium within 45 days prior
              to or during the policy period, the broadened coverage will
              immediately apply to this Coverage Part.
            </p>
          </div>
        </td>
        <td style="vertical-align: top">
          <p class="pl-16 text-justify">
            No person or organization, other than you, having custody of Covered
            Property will benefit from this insurance.
          </p>
          <h3 class="font-small"><b>G. OTHER INSURANCE</b></h3>
          <div class="pl-16">
            <ol>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                You may have other insurance subject to the same plan, terms,
                conditions and provisions as the insurance under this Coverage
                Part. If you do, we will pay our share of the covered loss or
                damage. Our share is the proportion that the applicable Limit of
                Insurance under this Coverage Part bears to the Limits of
                Insurance of all insurance covering on the same basis.
                </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                If there is other insurance covering the same loss or damage,
                other than that described in 1. above, we will pay only for the
                amount of covered loss or damage in excess of the amount due
                from that other insurance, whether you can collect on it or not.
                But we will not pay more than the applicable Limit of Insurance
                </span>
              </li>
            </ol>
          </div>
          <h3 class="font-small">
            <b>H. POLICY PERIOD, COVERAGE TERRITORY </b>
          </h3>
          <div class="pl-16">
            <p>Under this Coverage Part:</p>
            <ol style="list-style: none; counter-reset: item">
              <li style="counter-increment: item" class="text-justify">
                <b>1. &nbsp;</b
                ><span class="pl-8">We cover loss or damage commencing:</span>
                <div class="pl-16" style="padding-left: 10px; padding-bottom: 10px;">
                  <b>a. &nbsp;</b
                  ><span class="pl-8"
                    >During the policy period shown in the Declarations;
                    and</span
                  >
                </div>
                <div class="pl-16" style="padding-left: 10px; padding-bottom: 10px;">
                  <b>b.&nbsp;</b
                  ><span class="pl-8">Within the coverage territory.</span>
                </div>
              </li>
              <li style="counter-increment: item" class="text-justify">
                <b>2.&nbsp;</b><span class="pl-8">The coverage territory is:</span>
                <div class="text-justify pl-16" style="padding-left: 10px; padding-bottom: 10px;">
                  <b>a.&nbsp;</b
                  ><span class="pl-8"
                    >The United States of America (including its territories and
                    possessions);</span
                  >
                </div>
                <div class="text-justify pl-16" style="padding-left: 10px; padding-bottom: 10px;">
                  <b>b.&nbsp;</b><span class="pl-8">Puerto Rico; and</span>
                </div>
                <div class="text-justify pl-16" style="padding-left: 10px; padding-bottom: 10px;">
                  <b>c.&nbsp;</b><span class="pl-8">Canada.</span>
                </div>
              </li>
            </ol>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Page 2 -->
<div class="pdf-page app-cp-00-90-07-88">
  <table
    style="
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      border-spacing: 20px 0;
    "
  >
    <thead>
      <tr>
        <th style="width: 50%"></th>
        <th style="width: 50%"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="pl-16" style="vertical-align: top">
          <h3 class="font-small">
            <b>I. TRANSFER OF RIGHTS OF RECOVERY AGAINST OTHERS TO US </b>
          </h3>
          <div class="pl-16">
            <p class="text-justify">
              If any person or organization to or for whom we make payment under
              this Coverage Part has rights to recover damages from another,
              those rights are transferred to us to the extent of our payment.
              That person or organization must do everything necessary to secure
              our rights and must do nothing after loss to impair them. But you
              may waive your rights against another party in writing:
            </p>
          </div>
        </td>
        <td class="pl-16" style="vertical-align: top">
          <div class="pl-16">
            <ol style="list-style: none; counter-reset: item">
              <li style="counter-increment: item" class="text-justify">
                <b>1.</b
                ><span class="pl-8"
                  >Prior to a loss to your Covered Property or Covered
                  Income.</span
                >
              </li>
              <li style="counter-increment: item" class="text-justify">
                <b>2.</b
                ><span class="pl-8"
                  >After a loss to your Covered Property or Covered Income only
                  if, at time of loss, that party is one of the following:</span
                >
                <div class="pl-16">
                  <b>a.</b
                  ><span class="pl-8">Someone insured by this insurance;</span>
                </div>
                <div class="pl-16">
                  <b>b.</b><span class="pl-8">A business firm:</span>
                  <div class="pl-16">
                    <b>(1.)</b
                    ><span class="pl-8">Owned or controlled by you; or </span>
                    <br />
                    <b>(2.)</b
                    ><span class="pl-8">That owns or controls you; or</span>
                  </div>
                </div>
                <div class="pl-16">
                  <b>c.</b><span class="pl-8">Your tenant.</span>
                </div>
              </li>
            </ol>
            <p class="pl-16">This will not restrict your insurance.</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
